import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";
import PagamentosPage from "./pages/pagamentos";
import VisualizarPagamentosPage from "./pages/visualizarPagamentos";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
  pagamentos: PagamentosPage,
  visualizarPagamentos: VisualizarPagamentosPage,
};

const ContaFinanceiraPageController = () => {
  //estados globais
  const contaFinanceiraState = useAppSelector((state) => state.contaFinanceira);

  const Page = pages[contaFinanceiraState.page];

  return <Page key={contaFinanceiraState.page} />;
};

export default ContaFinanceiraPageController;
